import EmailRulesGateway from './EmailRulesGateway'

export default class EmailRulesService {
  constructor (emailRulesGateway) {
    this.EmailRulesGateway = emailRulesGateway || new EmailRulesGateway()

    this.getOperationsEmailRule = this.getOperationsEmailRule.bind(this)
    this.getParametersEmailRule = this.getParametersEmailRule.bind(this)
    this.getEmailRuleList = this.getEmailRuleList.bind(this)
    this.getEmailRule = this.getEmailRule.bind(this)
    this.createEmailRule = this.createEmailRule.bind(this)
    this.updateEmailRule = this.updateEmailRule.bind(this)
    this.deleteEmailRule = this.deleteEmailRule.bind(this)
  }

  getOperationsEmailRule () {
    return this.EmailRulesGateway
      .getOperationsEmailRule()
      .then(response => response)
  }

  getParametersEmailRule () {
    return this.EmailRulesGateway
      .getParametersEmailRule()
      .then(response => response)
  }

  getEmailRuleList () {
    return this.EmailRulesGateway
      .getEmailRuleList()
      .then(response => response.map(item => ({
        ...item,
        value: item.name
      })))
  }

  getEmailRule (params) {
    return this.EmailRulesGateway
      .getEmailRule(params)
      .then(response => response)
  }

  createEmailRule (query) {
    return this.EmailRulesGateway
      .createEmailRule(query)
      .then(response => response)
  }

  updateEmailRule (query) {
    return this.EmailRulesGateway
      .updateEmailRule(query)
      .then(response => response)
  }

  deleteEmailRule (query) {
    return new Promise(resolve => resolve({ status: 'success' }))
    // return this.EmailRulesGateway
    //   .deleteEmailRule(query)
    //   .then(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/api/email-rules/EmailRulesService.js